import React from "react";
import bgimage from "../../../assets/img/Nokia-overview.png";
import { useHistory } from "react-router-dom";

const DefaultPage = ({ newChatStart }) => {
  const history = useHistory();

  return (
    <div className="mx-auto">
      <div className="flex flex-col gap 2">
        <div>
          <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#005AFF] to-[#005AFF] mb-4 mt-4">
            Welcome to News Engine!
          </h1>

          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            Your Gateway to Real-Time FWA Intelligence to identify key growth
            drivers with ease.
          </h2>

          <p className="text-gray-600 mb-2 leading-relaxed max-w-6xl">
            Discover the power of News Engine, the smart platform built to
            simplify market intelligence. Tool enables you to select custom date
            ranges and instantly generate in-depth, data-driven summaries of the
            French Fixed Wireless Access (FWA) market. From customer adoption
            trends to regulatory updates and emerging opportunities, News Engine
            turns complex data into clear, actionable insights enabling faster
            decisions and a sharper edge in a dynamic landscape.
          </p>

          <div className="max-w-4xl">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Why News Engine?
            </h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>
                📊 <span className="font-medium">Custom Date Ranges</span> –
                Generate focused, in-depth summaries tailored to your needs.
              </li>
              <li>
                ⚡ <span className="font-medium">Instant Insights</span> –
                Access real-time intelligence without lengthy manual research.
              </li>
              <li>
                🌍 <span className="font-medium">Market Coverage</span> – Stay
                updated on customer adoption trends, competitor moves, and
                regulatory updates.
              </li>
             
            </ul>
          </div>
        </div>

        <div style={{ minHeight: "20px" }}></div>

        <div
          style={{
            backgroundImage: `url(${bgimage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="bg-black rounded-2xl p-8 relative overflow-hidden h-[270px]"
        >
          <div className="relative z-10">
            <h3 className="text-2xl font-bold bg-clip-text bg-gradient-to-r text-[#005AFF] mb-4">
              Ask AI
            </h3>
            <p className="text-white mb-6 max-w-[60%]">
            Your decision intelligence platform for FWA analysis, turning complex data into clear, actionable insights. Quickly uncover key growth drivers and make faster, smarter decisions in a dynamic market.
            </p>
            <div className="flex space-x-4">
              <button
                onClick={newChatStart}
                className="flex items-center space-x-2 px-6 py-2 border border-gray-600 rounded-lg text-white hover:bg-white/10 transition-colors bg-transparent"
              >
                <div className="w-4 h-4 border border-current rounded-full flex items-center justify-center">
                  <div className="w-2 h-2 bg-current rounded-full"></div>
                </div>
                <span>Start Chat</span>
              </button>
              <button
                onClick={() => {
                  history.push("/Generate-Summary");
                  newChatStart();
                }}
                className="px-6 py-2 border border-gray-600 rounded-lg text-white hover:bg-white/10 transition-colors bg-transparent"
              >
                Research Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultPage;
